var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cvty9sr23a",
    d: "M19.022 4.255L10.386.088c-.243-.117-.53-.117-.773 0L.977 4.255c-.174.083-.306.227-.385.385C.541 4.742.5 4.915.5 5v4.804c0 .46.387.834.864.834.476 0 .863-.374.863-.834V6.232l1.728.667v4.085c0 .316.184.604.477.746 1.485.716 3.01 1.6 5.568 1.6 2.557 0 4.084-.885 5.568-1.6.293-.142.478-.43.478-.746V6.9l2.912-1.124c.315-.122.527-.411.541-.74.015-.328-.173-.632-.477-.78zm-4.704 6.214l-.842.406c-2.177 1.051-4.776 1.051-6.952 0l-.842-.406V7.565L9.679 9.11c.103.04.212.058.321.058.109 0 .218-.018.321-.06l3.997-1.543v2.905zM1.364 11.667c.476 0 .863.373.863.833v1.667c0 .46-.387.833-.863.833-.477 0-.864-.372-.864-.833V12.5c0-.46.387-.833.864-.833zM10 1.767l6.53 3.148L10 7.436l-6.53-2.52L10 1.765z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-232 -330) translate(40 330) translate(194 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#cvty9sr23a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation_cap.fd8e2465.svg";
export { ForwardRef as ReactComponent };